import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { store } from "./app/store";

import "./styles/milliyo-tokens.css";
import "./styles/milliyo.css";
import "./styles/admin-rebrand.css";
import "./styles/admin-elite.css";
/* last, so the light/dark surface tokens win over the template's own rules */
import "./styles/milliyo-theme.css";

import AdminApp from "./pages/admin/AdminApp";
import AdminSignIn from "./pages/admin/auth/SignIn";
import Privacy from "./pages/users/Privacy";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./ScrollToTop";


const root = ReactDOM.createRoot(document.getElementById("root"));

// In your index.js (or main routing file)
// In your main index.js file
root.render(
  <Provider store={store}>
    <BrowserRouter>
    <ScrollToTop />
    {/* Styled in milliyo-theme.css under "Toasts": the class names below are
        the hooks. A toast is part of this portal, not a widget dropped on it. */}
    <ToastContainer
      position="top-right"
      autoClose={3200}
      newestOnTop
      closeOnClick
      pauseOnHover
      pauseOnFocusLoss={false}
      draggable={false}
      limit={4}
      toastClassName="mly-toast"
    />
      <Routes>

        {/* ✅ ADMIN LOGIN (PUBLIC) */}
        <Route path="/admin/login" element={<AdminSignIn />} />

        {/* Public policy page (linked from the app stores + login) */}
        <Route path="/privacypolicy" element={<Privacy />} />

        {/* ✅ ADMIN (PROTECTED) */}
        <Route path="/admin/*" element={<AdminApp />} />

        {/* The web is admin-only: every other path (incl. the root and the
            retired customer storefront) lands on the admin login. */}
        <Route path="*" element={<Navigate to="/admin/login" replace />} />
      </Routes>
    </BrowserRouter>
  </Provider>
);
